module.exports = __webpack_public_path__ + "img/link3.5acb0ebf.png";